import { SERVICES } from "@/lib/site-data";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-white py-24 md:py-32 border-t border-slate-200"
    >
      <div className="container-narrow">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-6">
            <div className="overline text-emerald-800 mb-5">— Services</div>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight leading-tight text-slate-950">
              A management practice,<br />
              wired for delivery.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-slate-600 text-base md:text-lg leading-relaxed">
              We are practitioners — former CTOs, programme directors and
              regulatory leads. Every engagement is led by a partner who has
              done the work, not just sold it.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
          {SERVICES.map((s) => (
            <div
              key={s.code}
              data-testid={`service-${s.code.toLowerCase()}`}
              className="bg-white p-8 md:p-10 hover:bg-stone-50 transition-colors"
            >
              <div className="flex items-start justify-between mb-6">
                <span className="overline text-slate-500">{s.code}</span>
                <span className="w-10 h-px bg-emerald-800 mt-2" />
              </div>
              <h3 className="font-serif text-2xl tracking-tight text-slate-950 mb-3">
                {s.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
